import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { registrationType } from '../Constants/RegistrationType';
import { RetreatGroupPageOptions } from '../Constants/RegistrationPageOptions';
import DataAccessHelper from '../Helper/DataAccessHelper';
import GenerateRandomCode from '../Helper/GenerateRandomCode.js';
import RetreatWeekSelection from '../Components/RetreatWeekSelection';
import GroupReservationTypeSelection from '../Components/GroupReservationTypeSelection';
import ReservationSpotSelection from '../Components/ReservationSpotSelection';
import ReservationReview from '../Components/ReservationReview';
import ReservationPayment from '../Components/ReservationPayment';
import '../Styles/RetreatGroupReservation.scss';

function RetreatGroupReservation() {

   const navigate = useNavigate();
   const [selectedPage, setSelectedPage] = useState(RetreatGroupPageOptions.WeekSelection);
   const [week, setWeek] = useState();
   const [numberOfSpots, setNumberOfSpots] = useState('');
   const [isFastTrack, setIsFastTrack] = useState(false);
   const [fastTrack, setFastTrack] = useState({
      selectedOption: '',
      fastTrackPromo1: '',
      fastTrackPromo2: '',
      freeRoomOption: false,
   });
   const [paymentAmount, setPaymentAmount] = useState(0.00);
   const [amountDue, setAmountDue] = useState(0.00);
   const [paymentType, setPaymentType] = useState('');
   const [account, setAccount] = useState();

   const eventRegistrationType = registrationType.RetreatGroup;

   async function validateAndProcessReservation(paymentIntentId) {
      try {
         const response = await fetch('/api/verify-payment', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ paymentIntentId }),
         });

         if (!response.ok) return false;

         const data = await response.json();
         if (data.result.status === 'succeeded') {
            ProcessReservation(paymentIntentId);
            return true;
         }
         return false;
      } catch (err) {
         console.error('Error validating payment intent:', err);
      }
   }

   async function ProcessReservation(paymentIntentId) {
      const reservationResult = await AddReservation();
      // Written even at $0 so every reservation has a row in the ledger.
      await AddTransaction(reservationResult, paymentIntentId);
      navigate('/reservationpaymentsuccess', { state: { paymentAmount } });
   }

   async function AddReservation() {
      const accountId = account.group_account_id;
      const groupCode = GenerateRandomCode.GenerateCode();
      try {
         const groupReservation = await fetch('/groupreservation', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               accountId,
               groupCode,
               week,
               fastTrack,
               isFastTrack,
               numberOfSpots
            })
         });
         const reservationResult = await groupReservation.json();
         return reservationResult.data.groupReservation[0].reservation_id;
      } catch (error) {
         console.log(error);
      }
   }

   async function AddTransaction(reservationId, paymentIntentId) {
      try {
         // Was /addreservationtransaction, which has no server route, so reservation payments were
         // never recorded. /addtransaction files it against reservation_id when no registId is sent.
         await fetch('/addtransaction', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               transactionValue: paymentAmount,
               reservationId,
               paymentType,
               paymentIntentId
            })
         });
      } catch (error) {
         console.log(error);
      }
   }

   async function GetAccountInformation() {
      const accountResponse = await DataAccessHelper.getCurrentAccountInformation();
      setAccount(accountResponse.account);
   }

   useEffect(() => {
      GetAccountInformation();
   }, []);

   return (
      <div className="retreatGroupReservationContainer">
         {selectedPage === RetreatGroupPageOptions.WeekSelection &&
            <RetreatWeekSelection
               nextPage={RetreatGroupPageOptions.ReservationTypeSelection}
               setSelectedPage={setSelectedPage}
               setWeekSelection={w => setWeek(w)}
            />
         }
         {selectedPage === RetreatGroupPageOptions.ReservationTypeSelection &&
            <GroupReservationTypeSelection
               selectedPage={selectedPage}
               setSelectedPage={setSelectedPage}
               isFastTrack={isFastTrack}
               setIsFastTrack={setIsFastTrack}
               nextPage={RetreatGroupPageOptions.ReservationSpotSelection}
            />
         }
         {selectedPage === RetreatGroupPageOptions.ReservationSpotSelection &&
            <ReservationSpotSelection
               numberOfSpots={numberOfSpots}
               setNumberOfSpots={setNumberOfSpots}
               setPaymentAmount={setPaymentAmount}
               isFastTrack={isFastTrack}
               fastTrack={fastTrack}
               setFastTrack={setFastTrack}
               selectedPage={selectedPage}
               setSelectedPage={setSelectedPage}
               week={week}
               nextPage={RetreatGroupPageOptions.Review}
            />
         }
         {selectedPage === RetreatGroupPageOptions.Review &&
            <ReservationReview
               paymentAmount={paymentAmount}
               amountDue={amountDue}
               isFastTrack={isFastTrack}
               fastTrack={fastTrack}
               numberOfSpots={numberOfSpots}
               week={week}
               selectedPage={selectedPage}
               setSelectedPage={setSelectedPage}
               ProcessReservation={ProcessReservation}
               previousPage={RetreatGroupPageOptions.ReservationSpotSelection}
               nextPage={RetreatGroupPageOptions.ReservationPayment}
            />
         }
         {selectedPage === RetreatGroupPageOptions.ReservationPayment &&
            <ReservationPayment
               account={account}
               amountDue={amountDue}
               setAmountDue={setAmountDue}
               paymentAmount={paymentAmount}
               setPaymentAmount={setPaymentAmount}
               paymentType={paymentType}
               setPaymentType={setPaymentType}
               numberOfSpots={numberOfSpots}
               week={week}
               validateAndProcessReservation={validateAndProcessReservation}
               selectedPage={selectedPage}
               setSelectedPage={setSelectedPage}
            />
         }
      </div>
   )
}

export default RetreatGroupReservation;
